import React from 'react';
import './ParcaPickerNestedModal.css';

/**
 * Geniş parça seçim diyaloğu — ana modal üzerinde tam ekran yakın picker alanı.
 */
const ParcaPickerNestedModal = ({
  open,
  onClose,
  title = 'Parça seç',
  selectedCount = 0,
  onShowSelected,
  footerLabel = 'Tamam',
  overlayExtras = null,
  /** 'picker' | 'category' — category daha dar kategori ağacı modalı */
  size = 'picker',
  children,
}) => {
  if (!open) return null;

  return (
    <div
      className="parca-picker-nested-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div
        className={`parca-picker-nested-dialog${
          size === 'category'
            ? ' parca-picker-nested-dialog--category'
            : ' parca-picker-nested-dialog--picker'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="parca-picker-nested-head">
          <div className="parca-picker-nested-head-main">
            <h3>{title}</h3>
            {onShowSelected != null && (
              <button
                type="button"
                className={`parca-picker-selected-badge${
                  selectedCount > 0 ? ' parca-picker-selected-badge--active' : ''
                }`}
                onClick={() => selectedCount > 0 && onShowSelected()}
                disabled={selectedCount === 0}
                title={
                  selectedCount > 0
                    ? 'Seçilen parçaları görüntüle'
                    : 'Henüz parça eklenmedi'
                }
                aria-label={`Seçilen parçalar: ${selectedCount}`}
              >
                <i className="fas fa-clipboard-list" aria-hidden />
                <span className="parca-picker-selected-badge-count">{selectedCount}</span>
              </button>
            )}
          </div>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="parca-picker-nested-body parca-picker-nested-body--picker">
          <div className="parca-picker-nested-shell">{children}</div>
        </div>
        <div className="parca-picker-nested-footer">
          <button type="button" className="btn btn-primary" onClick={onClose}>
            {footerLabel}
          </button>
        </div>
      </div>
      {overlayExtras}
    </div>
  );
};

export default ParcaPickerNestedModal;
